import * as React from 'react'
import * as ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { applyMiddleware, createStore } from 'redux'
import reduxSaga from 'redux-saga'
import ducks from './ducks'
import { Routes } from './routes'
import apiCallSaga from './sagas/apiCallSaga'
import { ThemeProvider } from 'styled-components'
import { defaultTheme } from './theme/defaultTheme'
import { config } from 'dotenv'
import './index.css'

config()

// create the saga middleware
const sagaMiddleware = reduxSaga()

const createStoreWithMiddleware = applyMiddleware(sagaMiddleware)

// redux devtools extension
const w: any = window as any
const devtools: any = w.devToolsExtension ? w.devToolsExtension() : (f: any) => f

const store = createStoreWithMiddleware(devtools(createStore))(ducks)

sagaMiddleware.run(apiCallSaga)

ReactDOM.render(
  <Provider store={store}>
    <ThemeProvider theme={defaultTheme} >
      <Routes />
    </ThemeProvider>
  </Provider>,
  document.getElementById('root') as HTMLElement
)



// WEBPACK FOOTER //
// ./src/index.tsx